export default "__VITE_ASSET__DbBbkKJk__"